import { ReactElement, useEffect, useState } from "react";

type Props = {
  children: ReactElement;
  delay: number;
};

export const Delay = ({ children, delay = 1000 }: Props) => {
  const [timeOut, setTimeOut] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setTimeOut(true);
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [delay]);

  return timeOut ? children : null;
};
